// extracted by mini-css-extract-plugin
export default {"root":"StatusMessage_root__R80bj","success":"StatusMessage_success__dsN+S","error":"StatusMessage_error__0GhLw","icon":"StatusMessage_icon__HP7hi"};